export { Badge } from './badge';
export type { BadgeProps, BadgeStylesNames } from './badge';
export type { BadgeStylesParams, BadgeVariant } from './badge.styles';
